module.exports = __webpack_public_path__ + "img/Weapon_81.b68dfa38.png";